import type { TFICDocument } from '../types/Document.ts';

export function isCapitalisableBill(document: TFICDocument): boolean {
    return document.editable_bill?.content_type === 'bill'
        && document.editable_bill.document_direction === 'purchase_invoice'
        && !document.editable_bill.is_credit_note
        && document.is_booked !== true;
}

export function shouldShowFixedAssetPanel(canLinkFixedAssets: boolean, document: TFICDocument): boolean {
    return canLinkFixedAssets && (isCapitalisableBill(document) || !!document.fixed_asset);
}
